module Client.Admin.ManageApplications.Grid

open Shared
open Shared.Admin
open Client.Admin
open Client
open Elmish
open Illy.SafeStack.Client 
open Illy.SafeStack.Client.jQueryUI
open Fable.React
open SafeStack.Client

type Model = 
    {
        Grid: UserGrid.Model
        Edit: Edit.Model option
    }

type Msg =
    | GridMsg of UserGrid.Msg
    | EditApplicationsForUser of UserId
    | EditMsg of Edit.Msg
    | EndNotification 

type Event =
    | ApiError of ApiError
    | CloseOverlay

let init () = 
    let tm, tc = UserGrid.init {UserGrid.IncludeUsersFilter.all with Disabled = false}
    {
        Grid = tm
        Edit = None
    }, Cmd.map GridMsg tc

let dispatchEditMsg model msg =
    match model.Edit with 
    | None -> model, SideEffect.none
    | Some ma -> 
        let m, eff = Edit.update ma msg  
        match eff with 
        | SideEffect.Cmd c -> {model with Edit = Some m}, Cmd.map EditMsg c |> SideEffect.Cmd 
        | SideEffect.Event ev -> 
            match ev with 
            | Edit.Event.ApiError err -> {model with Edit = Some m}, err |> Event.ApiError |> SideEffect.Event
            | Edit.Event.CloseOverlay -> {model with Edit = None}, SideEffect.none
            | Edit.Event.SaveSuccessful notification -> 
                {model with Edit = None}, 
                Cmd.batch [
                    Notification.success notification EndNotification
                    UserGrid.RefreshGrid |> GridMsg |> Cmd.ofMsg
                ] |> SideEffect.Cmd

let update msg model = 
    match msg with 
    | GridMsg uMsg ->
        let m, eff = UserGrid.update uMsg model.Grid
        {model with Grid = m},
        match eff with 
        | SideEffect.Cmd c -> Cmd.map GridMsg c |> SideEffect.Cmd
        | SideEffect.Event ev ->
            match ev with
            | UserGrid.Event.ApiError err -> err |> ApiError |> SideEffect.Event
            | UserGrid.Event.CloseOverlay -> CloseOverlay |> SideEffect.Event
    | EditApplicationsForUser userId -> 
        let m, c = Edit.init userId
        {model with Edit = Some m}, Cmd.map EditMsg c |> SideEffect.Cmd
    | EditMsg lMsg -> dispatchEditMsg model lMsg
    | EndNotification -> model, SideEffect.none

let view (model: Model) dispatch =
    [
        if model.Edit.IsNone then 
            yield! UserGrid.viewModal "Change Application Access" model.Grid (GridMsg >> dispatch) [
                UserGrid.GridColumn.name (UserGrid.isLoadingMoreResults model.Grid) model.Grid.SortInfo (GridMsg >> dispatch)
                UserGrid.GridColumn.username (UserGrid.isLoadingMoreResults model.Grid) model.Grid.SortInfo (GridMsg >> dispatch)
                Some [ str "Actions" ] ===> fun u -> [ UI.button "Manage" (EditApplicationsForUser (UserId u.Id)) dispatch ]
            ]
        yield! jQueryUI.conditionallyRenderView model.Edit Edit.view EditMsg dispatch
    ]
    
